<template>
  <div>
    <v-progress-linear v-if="cargando" indeterminate color="purple" class="mb-2" />

    <ag-grid-vue
      :gridOptions="gridOptions"
      class="ag-theme-balham ag-grid-listado-inscripciones-programa-universidad"
      :columnDefs="columnDefs"
      :defaultColDef="defaultColDef"
      @grid-ready="onGridReady"
      :rowData="items"
      rowSelection="single"
      colResizeDefault="shift"
      :animateRows="false"
      :floatingFilter="true"
      :pagination="false"
      :rowClassRules="rowClassRules"
      @selection-changed="onSelectionChanged"
      @first-data-rendered="onFirstDataRendered"
      :alwaysShowVerticalScroll="true"
      :suppressPaginationPanel="true">
    </ag-grid-vue>
  </div>
</template>
  
<script>
import listadoAgGridMixin from '../mixins/listado-ag-grid.mixin';
import { COLORES_ESTADOS_ADMINISTRATIVOS, COLORES_ESTADOS_CARTERA, ESTADOS_INSCRIPCION } from '../utils/constantes';
import {
  cellRendererNumeroRegistro,
  formatearValorAMoneda,
  imprimirProgramaModulo,
  obtenerInscripcionModuloMasAlto,
} from '../utils/funciones';
import Boton2HistorialEstadosAcademicos from './Boton2HistorialEstadosAcademicos.vue';
import BotonModuloActual2 from './BotonModuloActual2.vue';
import BotonMontoTotalConceptos2 from './BotonMontoTotalConceptos2.vue';
import columnasMontosMixin from '../mixins/columnas-montos.mixin';

export default {
  name: 'ListadoInscripcionesProgramaUniversidad',
  mixins: [listadoAgGridMixin, columnasMontosMixin],
  components: {
    // eslint-disable-next-line vue/no-unused-components
    Boton2HistorialEstadosAcademicos,
    // eslint-disable-next-line vue/no-unused-components
    BotonModuloActual2,
    // eslint-disable-next-line vue/no-unused-components
    BotonMontoTotalConceptos2,
  },
  computed: {
    universidadId() {
      if (this.items.length > 0) {
        return this.items[0]?.inscripcion?.programa?.universidadId;
      }

      return null;
    },
  },
  watch: {
    universidadId: {
      handler: function (value) {
        if (value == this.universidadIdUnivPando) {
          this.quitarColumnasPagos();
        } else {
          this.agregarColumnasPagos();
        }

        this?.agGridApi?.setGridOptions('columnDefs', this.columnDefs);
      },
      immediate: true,
    },
  },
  data() {
    return {
      universidadIdUnivPando: 49,
      columnDefs: [
        {
          headerName: 'N° REGISTRO',
          cellRenderer: cellRendererNumeroRegistro,
          filter: false,
          checkboxSelection: true,
          headerCheckboxSelectionFilteredOnly: true,
          headerCheckboxSelection: false,
          minWidth: 100,
          maxWidth: 100,
        },
        {
          headerName: 'TIPO INSCRIPCIÓN',
          cellRenderer: (params) => {
            return params.data?.detalleSolicitudInscripcionId === null ? 'DIRECTA' : 'POR SOLICITUD';
          },
          valueGetter: (params) => {
            return params.data?.detalleSolicitudInscripcionId === null ? 'DIRECTA' : 'POR SOLICITUD';
          },
          filter: false,
          minWidth: 130,
          maxWidth: 130,
        },
        {
          headerName: 'ESTADO ACTUAL',
          cellRenderer: (params) => {
            const estadoInscripcion = params.data?.inscripcion?.estadoInscripcion;
            const estado = ESTADOS_INSCRIPCION[estadoInscripcion];
            let color = 'black';

            if (estadoInscripcion == 1) {
              color = 'green';
            } else if (estadoInscripcion == 2) {
              color = 'red';
            } else {
              color = 'blue';
            }

            return /*html*/ `
              <span class="v-chip v-chip--outlined v-chip--pill theme--dark v-size--x-small ${color} ${color}--text body-2">
                  <span class="v-chip__content">
                    ${estado}
                  </span>
              </span>
            `;
          },
          valueGetter: (params) => {
            const estadoInscripcion = params.data?.inscripcion?.estadoInscripcion;

            return ESTADOS_INSCRIPCION[estadoInscripcion];
          },
          minWidth: 150,
          maxWidth: 150,
        },
        {
          headerName: 'CON SOLICITUD DE PAGOS',
          cellRenderer: (params) => {
            const tieneSolicitudesDePagos = params.data?.detallesSolicitudesPagos?.length > 0;
            const color = tieneSolicitudesDePagos ? 'green' : 'red';

            return /*html*/ `
              <span class="v-chip v-chip--outlined v-chip--pill theme--dark v-size--x-small ${color} ${color}--text body-2">
                  <span class="v-chip__content"> ${tieneSolicitudesDePagos ? 'SI' : 'NO'}</span>
              </span>
            `;
          },
          valueGetter: (params) => {
            return params.data?.detallesSolicitudesPagos.length > 0 ? 'SI' : 'NO';
          },
          filter: false,
          minWidth: 175,
          maxWidth: 175,
        },
        {
          headerName: 'ESTADO DE CARTERA',
          cellRenderer: (params) => {
            const estadoCartera = params.data?.inscripcion?.estadoCartera.nombre;

            if (!estadoCartera) {
              return '-';
            }

            const color = COLORES_ESTADOS_CARTERA[estadoCartera] || 'black';

            return /*html*/ `
                  <span class="v-chip v-chip--outlined v-chip--pill theme--dark v-size--x-small ${color} ${color}--text body-2">
                      <span class="v-chip__content">
                        ${estadoCartera}
                      </span>
                  </span>
                `;
          },
          filter: true,
          valueGetter: (params) => {
            const estadoCartera = params.data?.inscripcion?.estadoCartera.nombre;

            return estadoCartera;
          },
          minWidth: 220,
          maxWidth: 220,
        },
        {
          headerName: 'ESTADO ADMINISTRATIVO',
          cellRenderer: (params) => {
            const estadoAdministrativo = params.data?.inscripcion?.estadoAdministrativo.nombre;

            if (!estadoAdministrativo) {
              return '-';
            }

            const color = COLORES_ESTADOS_ADMINISTRATIVOS[estadoAdministrativo] || 'black';

            return /*html*/ `
                  <span class="v-chip v-chip--outlined v-chip--pill theme--dark v-size--x-small ${color} ${color}--text body-2">
                      <span class="v-chip__content">
                        ${estadoAdministrativo}
                      </span>
                  </span>
                `;
          },
          filter: true,
          valueGetter: (params) => {
            const estadoAdministrativo = params.data?.inscripcion?.estadoAdministrativo.nombre;

            if (!estadoAdministrativo) {
              return '-';
            }

            return estadoAdministrativo;
          },
          minWidth: 180,
          maxWidth: 180,
        },
        {
          headerName: 'ESTADO ACADÉMICO',
          cellRenderer: 'Boton2HistorialEstadosAcademicos',
          valueGetter: (params) => {
            const estadoAcademico = params.data?.inscripcion?.estadoAcademico?.nombre;

            return estadoAcademico;
          },
          filter: true,
          minWidth: 250,
          maxWidth: 250,
        },
        {
          headerName: 'MÓDULO ACTUAL',
          cellRenderer: 'BotonModuloActual2',
          filter: true,
          valueGetter: (params) => {
            const inscripcionesModulos = params.data?.inscripcionesModulos;
            const inscripcionModuloMasAlto = obtenerInscripcionModuloMasAlto(inscripcionesModulos);

            return imprimirProgramaModulo(inscripcionModuloMasAlto);
          },
          minWidth: 200,
          maxWidth: 200,
        },
        {
          headerName: 'N° DOCUMENTO',
          field: 'inscripcion.estudiante.numeroDocumento',
          minWidth: 120,
          maxWidth: 120,
        },
        {
          headerName: 'EXPEDIDO',
          cellRenderer: (params) => {
            const expedido = params.data?.inscripcion?.estudiante?.departamento?.extension.toUpperCase();

            return expedido || '-';
          },
          valueGetter: (params) => {
            return params.data?.inscripcion?.estudiante?.departamento?.extension;
          },
          false: false,
          minWidth: 100,
          maxWidth: 100,
        },
        {
          headerName: 'PRIMER APELLIDO',
          field: 'inscripcion.estudiante.primerApellido',
          minWidth: 180,
        },
        {
          headerName: 'SEGUNDO APELLIDO',
          field: 'inscripcion.estudiante.segundoApellido',
          minWidth: 180,
        },
        {
          headerName: 'NOMBRES',
          field: 'inscripcion.estudiante.nombres',
          minWidth: 200,
        },
        {
          headerName: 'ID PROGRAMA',
          field: 'inscripcion.programa.id',
          minWidth: 120,
          maxWidth: 120,
        },
        {
          headerName: 'PROGRAMA',
          field: 'inscripcion.programa.nombreCompuesto',
          minWidth: 600,
        },
        {
          headerName: 'SEDE',
          field: 'inscripcion.programa.sede.nombre',
          minWidth: 160,
          maxWidth: 160,
        },
        {
          headerName: 'GÉNERO',
          cellRenderer: (params) => {
            const genero = params?.data?.inscripcion?.estudiante?.sexo;

            return genero === 'M' ? 'MASCULINO' : 'FEMENINO';
          },
          filter: false,
          minWidth: 100,
          maxWidth: 100,
        },
        {
          headerName: 'CELULAR',
          cellRenderer: (params) => {
            const estudiante = params?.data?.inscripcion?.estudiante;
            const celular = estudiante?.telefono1 || estudiante?.telefono2;

            return celular || '-';
          },
          minWidth: 120,
          maxWidth: 120,
        },
        {
          headerName: 'CORREO',
          cellRenderer: (params) => {
            const correo = params?.data?.inscripcion?.estudiante?.email;

            return correo || '-';
          },
          minWidth: 250,
        },
        {
          headerName: 'PROFESIÓN',
          cellRenderer: (params) => {
            const profesiones = params?.data?.inscripcion?.estudiante?.profesiones;

            return profesiones?.length ? profesiones[0].nombre : '-';
          },
          minWidth: 250,
        },
        {
          headerName: 'UNIV. TITULACIÓN',
          cellRenderer: (params) => {
            const universidad = params?.data?.inscripcion?.estudiante?.institucion?.nombre;

            return universidad || '-';
          },
          minWidth: 450,
        },
      ],
      columnasPagos: [
        {
          headerName: 'PAGO MÁTRICULA',
          cellRenderer: (params) => {
            const inscripcion = params.data?.inscripcion;
            const montos = inscripcion?.montos;

            if (!montos) {
              return '-';
            }

            return formatearValorAMoneda(montos?.pagoMatricula);
          },
          filter: false,
          minWidth: 150,
          maxWidth: 150,
          type: 'numericColumn',
        },
        {
          headerName: 'PAGO COLEGIATURA',
          cellRenderer: (params) => {
            const inscripcion = params.data?.inscripcion;
            const montos = inscripcion?.montos;

            if (!montos) {
              return '-';
            }

            return formatearValorAMoneda(montos?.pagoColegiatura);
          },
          filter: false,
          minWidth: 150,
          maxWidth: 150,
          type: 'numericColumn',
        },
        {
          headerName: 'PAGO CERTIFICACIÓN',
          cellRenderer: (params) => {
            const inscripcion = params.data?.inscripcion;
            const montos = inscripcion?.montos;

            if (!montos) {
              return '-';
            }

            return formatearValorAMoneda(montos?.pagoCertificacion);
          },
          filter: false,
          minWidth: 150,
          maxWidth: 150,
          type: 'numericColumn',
        },
        {
          headerName: 'MONTO TOTAL PAGADO',
          cellRenderer: 'BotonMontoTotalConceptos2',
          filter: false,
          minWidth: 200,
          maxWidth: 200,
          type: 'numericColumn',
        },
      ],
    };
  },
  methods: {},
};
</script>
  
<style>
@import '~ag-grid-community/dist/styles/ag-grid.css';
@import '~ag-grid-community/dist/styles/ag-theme-balham.css';

.ag-grid-listado-inscripciones-programa-universidad {
  height: calc(var(--vh, 1vh) * 100 - 24rem);
}
</style>
  